import React, { useContext, useEffect, useState } from "react";
import "./Activitse.css";

import axios from "axios";
import PurchaseModal from "./PurchaseModal";
import { serverInfo } from "../../../../../../App";

const Purchase = (props) => {
  const { imageCdnUrl } = useContext(serverInfo);
  const activities = props.event;

  const [modalShow, setModalShow] = React.useState(false);
  // const [activities, setActivities] = useState([]);
  const [singleActivityData, setSingleActivityData] = React.useState({});

  // useEffect(() => {
  //   axios.get(`api/user/marketplace/activities`).then((res) => {
  //     if (res.status === 200) {
  //       setActivities(res.data.data);
  //     }
  //   });
  // }, []);

  const openModal = (data) => {
    setModalShow(true);
  };
  const modalData = (activity) => {
    setSingleActivityData(activity);
  };
  return (
    <>
      <div className="row mt-3">
        {/* {activities.} */}
        {activities.map((activity, i) => (
          <div class="col-md-6 col-lg-4 mb-3">
            <div className="card text-center CardEn ">
              <img
                src={
                  imageCdnUrl + activity?.market_place_order?.marketplace?.image
                }
                alt="Img1"
                className="ImgAc"
                height="180px"
              />

              {/* <Link to="/learning-activities"> */}
              <h6 className="fw-bold pt-3 pb-1 EnHead">
                {activity?.market_place_order?.marketplace?.title}
              </h6>

              <button
                className="btn-x-r-ac"
                style={{ fontSize: "30px" }}
                onClick={() => {
                  // openModal(activity)
                  setModalShow(true);
                  modalData(activity?.market_place_order);
                }}
              >
                <i className="fas fa-arrow-alt-circle-right"></i>
              </button>
              {/* </Link> */}
            </div>
          </div>
        ))}
        <PurchaseModal
          show={modalShow}
          onHide={() => setModalShow(false)}
          activity={singleActivityData}
        />
      </div>
    </>
  );
};

export default Purchase;
